import { Injectable, Injector, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { LanguageService } from './language.service';

const APP_NAME = 'Pouch';

/** Sets the browser tab title from each route's `title`, e.g. "Records · Pouch". */
@Injectable({ providedIn: 'root' })
export class AppTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  // LanguageService is looked up lazily: injecting it here creates a cycle at startup
  // (Router -> TitleStrategy -> LanguageService -> HttpClient -> interceptor -> Router).
  private readonly injector = inject(Injector);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const pageTitle = this.buildTitle(snapshot);
    if (!pageTitle) {
      this.title.setTitle(APP_NAME);
      return;
    }
    let text = pageTitle;
    try {
      text = this.injector.get(LanguageService).instant(pageTitle);
    } catch {
      // Fall back to the English title
    }
    this.title.setTitle(`${text} · ${APP_NAME}`);
  }
}
